import { queryContextClassifyTreeWithChild } from "@/app/shop/api/shopping";

const nav = {
  state: {
    brandList: [],
    currentBrand: []
  },

  mutations: {
    INIT_BRAND_LIST: (state, treeData) => {
      if (treeData && treeData.length > 0) {
        const brandList = [];
        treeData.forEach(item => {
          const { faqClassifyId, title, faqProblemBOs } = item;
          const child = faqProblemBOs
            .filter(item => item.columnStatus)
            .map(item => {
              return {
                id: item.faqId,
                activeIndex: item.faqId,
                name: item.faqName,
                source: item.docCode,
                parentId: faqClassifyId
              };
            });
          const node = {
            id: faqClassifyId,
            activeIndex: faqClassifyId,
            name: title,
            child: child.length ? child : null,
            to: child.length ? null : "/"
          };
          brandList.push(node);
        });
        state.brandList = brandList;
      }
    },
    SET_CURRENT_BRAND: (state, data) => {
      const currentBrand = [];
      const parentNode = state.brandList.find(
        item => item.id === data.parentId
      );
      if (parentNode) {
        currentBrand.push({
          title: parentNode.name
        });
      }
      const childNode = parentNode.child.find(item => item.id === data.childId);
      currentBrand.push({
        title: childNode.name
      });
      state.currentBrand = currentBrand;
    },
    SET_AUTO_BRAND: (state, data) => {
      state.currentBrand = [...state.currentBrand, data];
    }
  },

  actions: {
    async getNavTree({ commit }) {
      try {
        const res = await queryContextClassifyTreeWithChild({
          appUId: "100068",
          titleCode: "1800-",
          menuFlag: "3"
        });
        if (res.data.code === "0") {
          commit("INIT_BRAND_LIST", res.data.data.treeList);
        }
      } catch (error) {
        // console.log(error);
      }
    },
    setCurrentBrand({ commit }, node) {
      commit("SET_CURRENT_BRAND", node);
    },
    setAutoBrand({ commit }, data) {
      commit("SET_AUTO_BRAND", data);
    }
  },
  getters: {
    getBrandList: state => {
      return state.brandList;
    },
    getCurrentBrand: state => {
      return state.currentBrand;
    }
  }
};

export default nav;
